import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import ProfessionSpecialty from '../ProfessionSpecialty';
import Input from '../Input';
import Select from '../Select';
import SelectTheaterField from '../../containers/Others/SelectTheaterField';
import SaleRentOptions from '../../utils/selectors/SaleRentOptions';
import Authorization from '../Authorization';
import Countries from '../../utils/Countries';
import { VENUES_PLAN, FULL_PLAN, PRODUCERS_PLAN } from '../../constants';

class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.button = null;

    this.state = {
      advanced: props.advanced,
    };
  }

  process = (values) => {
    const { advanced } = this.state;
    const toSearch = {
      advanced,
    };

    const keys = [
      'budget', 'theater', 'elements',
      'saleOrRent', 'productionType',
      'query', 'kind', 'artists',
      'profession', 'specialty',
      'country',
    ];

    keys.forEach((k) => {
      if ({}.hasOwnProperty.call(values, k)
        && values[k] !== '' && values[k] !== undefined
        && values[k] !== null
      ) {
        toSearch[k] = values[k];
      }
    });

    this.props.onSearch(toSearch);
  };

  toggleSearch(event) {
    event.preventDefault();
    const to = !this.state.advanced;
    this.setState({ advanced: to });
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter' && this.button !== null) {
      event.preventDefault();
      this.button.click();
    }
  };

  renderAdvanced = (kind) => {
    if (kind === 'elements') {
      return (
        <div>
          <div className="row search__row">
            <div className="col-md-4">
              <Select
                name="kind"
                defaultOption={1}
                options={[
                    { value: 'productions', label: 'Producciones' },
                    { value: 'elements', label: 'Elementos' },
                  ]}
              />

            </div>
            <div className="col-md-4">
              <Select
                name="saleOrRent"
                options={SaleRentOptions}
              />
            </div>
            <div className="col-md-4">
              <Select
                name="elements"
                placeholder="Elementos"
                options={[
                  { value: 'sets', label: 'Escenografía/Sets' },
                  { value: 'costumes', label: 'Vestuario/Costumes' },
                  { value: 'titles', label: 'Sobretítulos/Titles' },
                  { value: 'props', label: 'Utilería/Props' },
                  { value: 'orchestration', label: 'Orquestación/Orchestration' },
                ]}
              />
            </div>
          </div>
          <div className="row search__row">
            <div className="col-md-6">
              <Authorization allowedPlans={[VENUES_PLAN, FULL_PLAN, PRODUCERS_PLAN]} >
                <SelectTheaterField />
              </Authorization>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="row search__row">
          <div className="col-md-4">
            <Select
              name="kind"
              defaultOption={1}
              options={[
                  { value: 'productions', label: 'Producciones' },
                  { value: 'elements', label: 'Elementos' },
                ]}
            />

          </div>
          <div className="col-md-4">
            <Select
              name="saleOrRent"
              placeholder="Venta / Arriendo"
              options={[
                { value: 'sale', label: 'Venta' },
                { value: 'rent', label: 'Arriendo' },
                { value: 'both', label: 'Ambos' },
              ]}
            />
          </div>
          <div className="col-md-4">
            <Select
              name="budget"
              placeholder="Presupuesto"
              options={[
                { value: 'f1', label: 'USD$0 - USD$15.000' },
                { value: 'f2', label: 'USD$15.001 - USD$35.000' },
                { value: 'f3', label: 'USD$35.001 - USD$50.000' },
                { value: 'f4', label: 'USD$50.001 - USD$100.000' },
                { value: 'f5', label: 'USD$100.001 - USD$400.000' },
                { value: 'f6', label: '> USD$400.000' },
              ]}
            />
          </div>
        </div>
        <div className="row search__row">
          <div className="col-md-6">
            <Input
              className="search__input"
              autoComplete="off"
              name="artists"
              placeholder="Realizador (regisseur, vestuarista, iluminador, escenógrafo, coreógrafo)."
            />
          </div>
          <div className="col-md-6">
            <Select
              name="productionType"
              placeholder="Genero"
              options={[
                { value: 'opera', label: 'Opera' },
                { value: 'ballet', label: 'Ballet' },
                { value: 'infantil', label: 'Infantil' },
                { value: 'otro', label: 'Otro' },
              ]}
            />
          </div>
        </div>
        <div className="row search__row">
          <Authorization allowedPlans={[VENUES_PLAN, FULL_PLAN, PRODUCERS_PLAN]} >
            <div className="col-md-6">
              <SelectTheaterField />
            </div>
          </Authorization>
        </div>
      </div>
    );
  };

  render() {
    const { artists } = this.props;
    return (
      <Formik
        enableReinitialize
        initialValues={{
          query: '',
          profession: undefined,
          specialty: undefined,
          kind: 'productions',
          productionType: undefined,
          budget: undefined,
          artists: '',
          saleOrRent: undefined,
          elements: '',
          theater: '',
          country: undefined,
        }}
        onSubmit={this.process}
        render={props => (
          <div
            className={
          `search-section-area ${
          this.props.mobile
            ? 'hidden-sm hidden-md hidden-lg '
            : 'hidden-xs '
          }${this.props.float ? 'search-area' : ''}`
        }
          >
            <div className="search-area-inner">
              <div className="search-contents show-search-area animated fadeInUp">
                <form onSubmit={props.handleSubmit}>
                  <div className="row">
                    <div className={`form-group ${artists ? 'col-md-6' : 'col-md-9'}`}>
                      <Input
                        name="query"
                        className="search__input"
                        autoComplete="off"
                        placeholder={!artists ?
                          'Busca una ópera, un ballet, un teatro o un realizador'
                          :
                          'Busca un artista, un realizador o un rol'
                        }
                        onKeyPress={this.handleKeyPress}
                      />
                    </div>
                    {artists && (
                    <ProfessionSpecialty
                      boxClassName="col-md-2"
                      hideLabel
                    />
                          )}
                    {artists && (
                      <div className="form-group">
                        <div className="col-md-2">
                          <Select
                            name="country"
                            placeholder="País"
                            options={Countries}
                          />
                        </div>
                      </div>
                    )}

                    <div className={`form-group ${artists ? 'col-md-2' : 'col-md-3'}`}>
                      <button
                        ref={(el) => { this.button = el; }}
                        type="submit"
                        className="search-button"
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                  {!artists && this.state.advanced && this.renderAdvanced(props.values.kind)}
                  {!artists && (
                  <div className="row search__row">
                    <div className="col-md-12">
                      <button
                        onClick={e => this.toggleSearch(e)}
                        className="btn"
                      >
                        {this.state.advanced
                        ? 'Buscador básico'
                        : 'Buscador avanzado'}
                      </button>
                    </div>
                  </div>
              )}
                </form>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

SearchBar.propTypes = {
  artists: PropTypes.bool,
  mobile: PropTypes.bool,
  float: PropTypes.bool,
  advanced: PropTypes.bool,
  type: PropTypes.string,
  onSearch: PropTypes.func,
};

SearchBar.defaultProps = {
  advanced: false,
  type: 'productions',
  mobile: false,
  float: false,
  artists: false,
  onSearch: () => {},
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js